import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import axios from 'axios';

const initialState = {
  isSubmitting: false,
  successMessage: null,
  error: null,
};

export const slice = createSlice({
  name: 'tdg',
  initialState,
  reducers: {
    setSubmitting(state, action) {
      state.isSubmitting = action.payload;
    },
    setSuccess(state, action) {
      state.successMessage = action.payload;
      state.error = null;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.successMessage = null;
    },
  },
});

export const { setSubmitting, setSuccess, hasError } = slice.actions;

export default slice.reducer;

export function submitTdgTopic(payload) {
  const API_URL = process.env.REACT_APP_API_URL || '';
  return async () => {
    dispatch(slice.actions.setSubmitting(true));
    try {
      const response = await axios.post(`${API_URL}/api/tdg-topic`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      dispatch(slice.actions.setSuccess(response.data?.message || 'TDG submitted'));
      return response;
    } catch (error) {
      console.error('TDG submit error', error);
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.setSubmitting(false));
    }
  };
}


